import React from "react";
import { useSelector } from "react-redux";
import UnopDropdown from "unop-react-dropdown";
import sort from "../../Images/sort.png";



const ProductsResults = ({ title, onClick }) => {
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const handler = () => { };
  const clickMe = (key) => {
    localStorage.setItem("sortType", key);
    onClick();
  };
  return (
    <div className="d-flex justify-content-between pt-3 px-2 mb-3">
      <div className="sub-tile" style={{ color: settingsRes?.data?.primaryColor }}>{title}</div>
      <div className="search-count-text d-flex ">
        <UnopDropdown
          onAppear={handler}
          onDisappearStart={handler}
          trigger={
            <p className="mx-1">
              <img
                width="20px"
                height="20px"
                className="ms-1"
                src={sort}
                alt=""
              />
              ترتيب حسب
            </p>
          }
          delay={0}
          align="CENTER"
          hover
        >
          <div className="card-filter">
            <div
              onClick={() => clickMe("")}
              className="border-bottom card-filter-item"
            >
              بدون ترتيب
            </div>
            <div
              onClick={() => clickMe("السعر من الاقل للاعلي")}
              className="border-bottom card-filter-item"
            >
              السعر من الاقل للاعلي
            </div>
            <div
              onClick={() => clickMe("السعر من الاعلي للاقل")}
              className=" card-filter-item"
            >
              السعر من الاعلي للاقل
            </div>
          </div>
        </UnopDropdown>
      </div>
    </div>
  );
};

export default ProductsResults;
